export default __webpack_public_path__ + "static/media/Fine Pharma2.024876ce.png";